import React from 'react';

export const Footer = () => (
  <div className="fixed p-1 bottom-0 left-0 w-full h-[4vh] text-center border-t border-gray-200 bg-white">
    © NYU GW LENR
  </div>
);